module.exports = __webpack_public_path__ + "d24987b907f6b8f15b833933564669d8.MP3";